import { useQuery } from '@tanstack/react-query';
import { getPool } from './api';
import { getStatusBadgeClass, formatRelativeTime } from './utils';

function PoolView() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['pool'],
    queryFn: async () => {
      const response = await getPool();
      return response.data;
    },
    refetchInterval: 30000,
  });

  if (isLoading) {
    return <div className="loading">Loading cache pool...</div>;
  }

  if (error) {
    return (
      <div className="error">
        <strong>Error loading pool:</strong> {error.message}
      </div>
    );
  }

  const vms = Array.isArray(data) ? data : (data?.items || []);

  if (vms.length === 0) {
    return (
      <div className="empty-state">
        <p>No VMs in the cache pool</p>
        <p style={{ fontSize: '0.85rem', color: '#94a3b8' }}>
          Add VMs via POST /api/orka/pool to seed the pool.
        </p>
      </div>
    );
  }

  return (
    <div className="section">
      <div className="section-header">
        <h2>Cache Pool</h2>
        <button className="btn btn-secondary" onClick={() => refetch()}>
          Refresh
        </button>
      </div>

      <div className="card-grid">
        {vms.map((vm) => (
          <div key={vm.name} className="card">
            <div className="card-title">
              <span>{vm.name}</span>
              <span className={`badge ${getStatusBadgeClass(vm.status)}`}>
                {vm.status || 'unknown'}
              </span>
            </div>

            <div className="card-content">
              {vm.currentImage && (
                <div className="info-row">
                  <span className="info-label">Current Image</span>
                  <span className="info-value">
                    <code>{vm.currentImage}</code>
                  </span>
                </div>
              )}

              {vm.agentName && (
                <div className="info-row">
                  <span className="info-label">TC Agent</span>
                  <span className="info-value">{vm.agentName}</span>
                </div>
              )}

              {vm.branch && (
                <div className="info-row">
                  <span className="info-label">Branch</span>
                  <span className="info-value">{vm.branch}</span>
                </div>
              )}

              {vm.cl && (
                <div className="info-row">
                  <span className="info-label">CL</span>
                  <span className="info-value">{vm.cl}</span>
                </div>
              )}

              <div className="info-row">
                <span className="info-label">Last Active</span>
                <span className="info-value">
                  {formatRelativeTime(vm.lastActivityAt)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PoolView;
